class AddressService {

    constructor($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    }

    locationBySearchText(text) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.locationBySearchText,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false,
                data: $.param({
                    'searchText': text,
                    'showOnlyValidCountries': 1,
                    'showOnlyCitiesInTransportRule': 0
                })
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    getAllDirections(userId = '',city='') {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.getAllDirections
                + '?usuarioId=' + userId + '&city='+ city ,
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    getDirectionById(idDirection) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.getDirection
                + '?idDirection=' + idDirection,
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    saveDirection(direction) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' +
                (direction.id ? this.ngAuthSettings.config.paths.editDirection : this.ngAuthSettings.config.paths.saveDirection),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false,
                data: direction
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    deleteDirection(idDirection) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.deleteDirection,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false,
                data: {'id': idDirection}
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

}

AddressService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default AddressService;



// WEBPACK FOOTER //
// ./www/components/address/address.service.js